import React, { useState, useEffect, useCallback } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { businessInfo } from '../data/mock';

const NAV_ITEMS = [
  { id: 'services', label: 'Services' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'quote', label: 'Quote' },
  { id: 'contact', label: 'Contact' },
];

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const linkClass = 'font-display uppercase tracking-wider font-semibold text-neutral-800 hover:text-red-600';

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        isScrolled || isMobileMenuOpen ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-3" data-testid="header-logo">
            <img src="/images/logo.png" alt="Stefen's Detailing" className="h-14 md:h-16 w-auto" />
            <span className="hidden sm:block font-display italic uppercase text-xl font-extrabold tracking-tight text-neutral-950">
              Stefen&apos;s <span className="text-red-600">Detailing</span>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <button key={item.id} type="button" onClick={() => scrollToSection(item.id)} className={linkClass} data-testid={`nav-${item.id}`}>
                {item.label}
              </button>
            ))}
            <a
              href={`tel:${businessInfo.phone}`}
              data-testid="header-phone-link"
              className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-4 py-2 rounded-sm"
            >
              <Phone className="w-4 h-4" />
              <span>{businessInfo.phone}</span>
            </a>
          </nav>

          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-neutral-950 p-2"
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="md:hidden pb-6 space-y-4" data-testid="mobile-nav">
            {NAV_ITEMS.map((item) => (
              <button key={item.id} type="button" onClick={() => scrollToSection(item.id)} className={`block w-full text-left ${linkClass}`} data-testid={`mobile-nav-${item.id}`}>
                {item.label}
              </button>
            ))}
            <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 text-red-600 font-semibold">
              <Phone className="w-4 h-4" />
              <span>{businessInfo.phone}</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};
